
import { Project } from "@/types";

export const filterProjects = (
  projects: Project[],
  searchTerm: string,
  stageFilter: string,
  statusFilter: string,
  riskFilter: string
) => {
  return projects.filter(project => {
    // Search term filter
    if (searchTerm && !project.name.toLowerCase().includes(searchTerm.toLowerCase()) && 
        !project.client.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !(project.referenceCode && project.referenceCode.toLowerCase().includes(searchTerm.toLowerCase()))) {
      return false;
    }
    
    // Stage filter
    if (stageFilter !== 'all' && project.currentStage !== parseInt(stageFilter)) {
      return false;
    }
    
    // Status filter
    const status = project.status || 'active';
    if (statusFilter !== 'all' && status !== statusFilter) {
      return false;
    }
    
    // Risk filter
    if (riskFilter !== 'all') {
      const highRisks = project.risks?.filter(risk => 
        risk.status === 'open' && (risk.impact * risk.probability >= 10)
      ).length || 0;
      
      if (riskFilter === 'high' && highRisks === 0) {
        return false;
      }
    }
    
    return true;
  });
};

export const sortProjects = (projects: Project[], sortBy: string) => {
  return [...projects].sort((a, b) => {
    switch (sortBy) {
      case 'name':
        return a.name.localeCompare(b.name);
      case 'stage':
        return a.currentStage - b.currentStage;
      case 'date':
        return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
      case 'progress':
        const progressA = calculateProgress(a);
        const progressB = calculateProgress(b);
        return progressB - progressA;  // Sort by highest progress first
      default:
        return 0;
    }
  });
};

export const calculateProgress = (project: Project) => {
  const totalStages = 8; // RIBA stages 0-7
  const completedStages = project.stages?.filter((s: any) => s.status === 'completed').length || 0;
  const currentStageProgress = project.stages?.[project.currentStage]?.progress || 0;
  
  const completeWeight = completedStages / totalStages;
  const currentWeight = 1 / totalStages * (currentStageProgress / 100);
  
  return Math.round((completeWeight + currentWeight) * 100);
};
